
import React, { Component}  from 'react';
import { DetailProvider, DetailContext } from 'core/DetailProvider';
import ChangesList from 'components/Changes/List';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import Layout  from 'components/Dashboard/Layout';

import { StyledClientDetailOrders, StyledClientBlock } from './Styled';
import ClientDetailHeader from "./DetailHeader";
import CounterpartyList from './CounterpartyList';


export default class ClientDetail extends Component {

  render() {
    const { match, history } = this.props;
    return (
      <DetailProvider
        url={`client/${match.params.id}`}
      >
        <DetailContext.Consumer>
          {context => {
            let { item } = context;

            return (
              <Layout>
                <StyledClientDetailOrders>
                  <div>
                    <ClientDetailHeader item={item} history={history} />

                    <Layout.ContentSimple>
                      <StyledClientBlock>
                        <div>
                          <label>Филиал</label>
                          {item.department.name}
                        </div>
                        <div className={'personal_manager-icon'}>
                          <span>
                            <PermIdentityIcon />
                          </span>
                        </div>
                        <div>
                          <label>Персональный менеджер</label>
                          {item.personal_manager && (
                            <div>{item.personal_manager.short_name}</div>
                          )}
                          {!item.personal_manager && <div>Не назначен</div>}
                        </div>
                      </StyledClientBlock>

                      <div className={'mt-30'}>
                        <CounterpartyList client={item} />
                      </div>
                    </Layout.ContentSimple>
                  </div>
                </StyledClientDetailOrders>
              </Layout>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
